import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useDebounce } from "use-debounce";
import Input from "../../components/input";
import { toast } from "react-toastify";
import { Paginator } from "../../components/Paginator";
import { TableCustom } from "../../components/Table";
import useAxiosInstance from "../../hooks/useAxios";



const AtlasSearch = () => {
  const axiosInstance = useAxiosInstance();
  const [query, setQuery] = useState("");
  const [debouncedQuery] = useDebounce(query, 600);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [intermidiatePageNumber, setIntermidiatePageNumber] = useState(1);
  const [pageMeta, setPageMeta] = useState({ current_page: 1, total_pages: 1, count: 0 });

  const params = useMemo(() => ({
    q: debouncedQuery,
    page: page,
    page_size: pageSize,
  }), [debouncedQuery, page, pageSize]);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    const request = debouncedQuery === ""
      ? axiosInstance.get(`/integrations/tech-search/create`, { params: { page, page_size: pageSize }, signal: controller.signal })
      : axiosInstance.get(`/integrations/tech-search/search`, { params, signal: controller.signal });

    request
      .then((res) => {
        
        const data = res?.data ?? {};
        const list = Array.isArray(data) ? data : (data?.results || data?.data || []);
        setResults(list);
        const count = Number(data?.total);
        const current_page =Number(data?.current_page ?? page);
        const total_pages =Number(data?.total_pages);
        setPageMeta({ current_page, total_pages, count });
        setIntermidiatePageNumber(current_page);
        setLoading(false);
      })
      .catch((err) => {
        if (err?.name === "CanceledError") return;
        console.log(err);
        toast.error("Something went wrong while loading functions");
        setLoading(false);
      });
    return () => controller.abort();
  }, [params]);

  return (
    <div className="p-6 w-full">
      <div className="text-2xl font-semibold">Atlas Search</div>

      <div className="mt-4">
        <div className="flex justify-between items-center w-full">
          <p className="text-sm font-semibold mb-4">Search Functions</p>
          <div className="flex items-center gap-2">
            <Link to={`/atlassearch/edit`}>
              <button className="text-sm underline">Create New</button>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 mt-1 gap-x-2">
          <Input
            className='w-full'
            placeholder='Search by name, path, or description'
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        {loading && <p className='mt-4'>Searching...</p>}
        {!loading && (
            <TableCustom
              columns={[
                { label: "Name", key: "function_name", width: "20%" },
                { label: "Path", key: "function_path", width: "25%" },
                { label: "Description", key: "function_description", width: "40%" },
                { label: "Score", key: "score", width: "10%" },
              ]}
              data={{ data: (results || []).map((func) => ({
                id: func?._id || func?.id,
                function_name: func?.function_name,
                function_path: func?.function_path,
                function_description: func?.function_description,
                score: func?.score ?? func?._score ?? '-'
              })) }}
              loading={loading}
              handleEdit={(id)=>{ window.location.href = `/atlassearch/edit?function_id=${encodeURIComponent(id)}`; }}
              handleDelete={null}
              handleSelect={null}
              className="max-w-full h-[60vh] !max-h-[60vh]"
            />
        )}

        {true && (
          <Paginator
            data={{ current_page: pageMeta.current_page, total_pages: pageMeta.total_pages, count: pageMeta.count }}
            loading={loading}
            setPage={setPage}
            setIntermidiatePageNumber={setIntermidiatePageNumber}
            intermidiatePageNumber={intermidiatePageNumber}
            setPageSize={(val) => setPageSize(Number(val))}
            pageSize={pageSize}
          />
        )}
      </div>
    </div>
  );
};

export default AtlasSearch;